import { SplitFactory } from "@splitsoftware/splitio-browserjs";
export default function getSplitClient(userId) {
    var factory = SplitFactory({
        core: {
            authorizationKey: process.env.SPLIT_API_KEY,
            // the key can be the logged in
            // user id, or the account id that
            // the logged in user belongs to.
            // The type of customer (user, account, custom)
            // is chosen during Split's sign-up process.
            key: userId,
        },
        startup: {
            readyTimeout: 1.5,
        },
    });
    return factory.client();
}
